/** An upload that got no HTTP answer at all: the connection dropped or it took over 60 s. */
export class UploadError extends Error {
  constructor(readonly reason: 'network' | 'timeout') {
    super(reason === 'network' ? 'Network error' : 'Upload timed out');
    this.name = 'UploadError';
  }
}
